import GlassFrogModel from 'legacy/GlassFrog/GlassFrogModel'

const Organization = GlassFrogModel.extend({}, {
  resourceName: 'organizations',
})

export default Organization
